// @ts-strict-ignore
import { DEFAULT_APP_INFO, loadDefaultLanguageCode } from 'mobile_web/modules/settings/functions'
import { RootStoreState } from 'mytours-read-common'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { saveAppLanguage } from '../../home/functions'

const WithContainerRoute =
	<P extends Record<string, any>>(Component: React.ComponentType<P>) =>
	(props: P) => {
		const [loading, setLoading] = useState(true)
		const appMetaData = useSelector((state: RootStoreState) => state.settings.appMetaData)

		useEffect(() => {
			if (!appMetaData) {
				return
			}

			handleSelectLanguage()
		}, [appMetaData])

		const handleSelectLanguage = async () => {
			const storedLanguageCode = await loadDefaultLanguageCode(DEFAULT_APP_INFO.projectId)

			const {
				match: { params },
			} = props
			saveAppLanguage({
				params,
				callback: () => setLoading(false),
				appMetaData,
				storedLanguageCode,
			})
		}

		if (loading) {
			return null
		}

		return <Component {...props} />
	}

export default WithContainerRoute
